import { atom } from "jotai";
import { type ColumnFiltersState } from "@design-system/Table";

export const columnFiltersAtom = atom<ColumnFiltersState>([]);